import { render, staticRenderFns } from "./formularioTromboembolico.vue?vue&type=template&id=1ba10294&scoped=true"
import script from "./formularioTromboembolico.vue?vue&type=script&lang=js"
export * from "./formularioTromboembolico.vue?vue&type=script&lang=js"
import style0 from "./formularioTromboembolico.vue?vue&type=style&index=0&id=1ba10294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba10294",
  null
  
)

export default component.exports